/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *  CopyIcon Icon
 * @author Anuja Gaikwad
 * @file CopyIcon.jsx
 */

import React from 'react';
import { SvgIcon } from '@material-ui/core';

function CopyIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4445 13.3333V14.2222C12.4445 15.2041 11.6485 16 10.6667 16H2.66669C1.68485 16 0.888916 15.2041 0.888916 14.2222V4.44444C0.888916 3.4626 1.68485 2.66667 2.66669 2.66667H3.55558V1.77778C3.55558 0.795938 4.35152 0 5.33336 0H11.1874C11.4231 0 11.6492 0.0936505 11.8159 0.26035L14.8508 3.29521C15.0175 3.46191 15.1111 3.688 15.1111 3.92375V11.5556C15.1111 12.5374 14.3152 13.3333 13.3334 13.3333H12.4445ZM10.8889 13.3333H5.33336C4.35152 13.3333 3.55558 12.5374 3.55558 11.5556V4.22222H2.66669C2.54396 4.22222 2.44447 4.32171 2.44447 4.44444V14.2222C2.44447 14.345 2.54396 14.4444 2.66669 14.4444H10.6667C10.7894 14.4444 10.8889 14.345 10.8889 14.2222V13.3333ZM13.5556 11.5556V4.44444H11.5556C11.0647 4.44444 10.6667 4.04648 10.6667 3.55556V1.55556H5.33336C5.21063 1.55556 5.11114 1.65505 5.11114 1.77778V11.5556C5.11114 11.6783 5.21063 11.7778 5.33336 11.7778H13.3334C13.4561 11.7778 13.5556 11.6783 13.5556 11.5556Z"
        fill="#171717"
      />
    </SvgIcon>
  );
}

export default CopyIcon;

